export const rowData: any = {
  type: "Component",
  json: {
    type: 'Row',
    label: 'Row',
    properties: {
      "styles": {
        "common": {
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "background": "#D20202",
            "textColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "borderWidth": 1,
            "borderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "width": "100",
          "heightMode": "px",
          "height": "80",
          "padding": "16",
          "backgroundColor": "#00000000",
          "borderColor": "#C5C8D4",
          "borderRadius": "10",
          "gap": "16",
          "border": "1"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "width": "100",
          "heightMode": "px",
          "height": "80",
          "padding": "16",
          "backgroundColor": "#00000000",
          "borderColor": "#C5C8D4",
          "borderRadius": "10",
          "gap": "16",
          "border": "1"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "width": "100",
          "heightMode": "px",
          "height": "80",
          "padding": "16",
          "backgroundColor": "#00000000",
          "borderColor": "#C5C8D4",
          "borderRadius": "10",
          "gap": "16",
          "border": "1"
        }
      },
      "config": {
        "visible": true,
        "enableBadge": false,
        "classNameTags": [],
        "onClick": "async function main(asset, flatlistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }",
        "renderOn": ""
      }
    }
  }
}

export const avatarData: any = {
  type: "Component",
  json: {
    type: 'Avatar',
    label: 'Avatar',
    properties: {
      "styles": {
        "common": {
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "background": "#D20202",
            "textColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "borderWidth": 1,
            "borderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "px",
          "width": "48",
          "height": "48"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "px",
          "width": "48",
          "height": "48"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "px",
          "width": "48",
          "height": "48"
        }
      },
      "config": {
        "visible": true,
        "bind": "",
        "classNameTags": [],
        "persistBlock": false,
        "avatarDimension": "48",
        "avatarUrl": "https://storage.googleapis.com/public-a8-bucket/24c2e9de-de12-42f5-b70a-55fcd21c7b83/apps/310a0b83-b512-40e8-a057-5a4fdf730534/large-photo1_1717071701424.svg",
        "enableBadge": false,
        "enableOnHistoryView": false,
        "onClick": "async function main(asset, flalistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }"
      }
    }
  }
}
export const columnData: any = {
  type: "Component",
  json: {
    type: 'Column',
    label: 'Column',
    properties: {
      "styles": {
        "common": {
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "background": "#D20202",
            "textColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "borderWidth": 1,
            "borderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "%",
          "height": "100",
          "width": "300",
          "backgroundColor": "#00000000",
          "padding": "0",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingBottom": "0",
          "paddingLeft": "0"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "%",
          "height": "100",
          "width": "300",
          "backgroundColor": "#00000000",
          "padding": "0",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingBottom": "0",
          "paddingLeft": "0"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "%",
          "height": "100",
          "width": "300",
          "backgroundColor": "#00000000",
          "padding": "0",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingBottom": "0",
          "paddingLeft": "0"
        }
      },
      "config": {
        "visible": true,
        "enableBadge": false,
        "classNameTags": [],
        "onClick": "async function main(asset, flatlistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }",
        "renderOn": ""
      }
    }
  }
}

export const nameText: any = {
  type: "Component",
  json: {
    type: 'Text',
    label: 'name',
    properties: {
      "styles": {
        "common": {
          "textAlign": "",
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "badgeBackground": "#D20202",
            "badgeTextColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "badgeBorderWidth": 1,
            "badgeBorderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "16",
          "width": "100",
          "fontWeight": "600",
          "height": "25",
          "color": "#27272E",
          "backgroundColor": "#00000000"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "16",
          "width": "100",
          "fontWeight": "600",
          "height": "25",
          "color": "#27272E",
          "backgroundColor": "#00000000"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "16",
          "width": "100",
          "fontWeight": "600",
          "height": "25",
          "color": "#27272E",
          "backgroundColor": "#00000000"
        }
      },
      "config": {
        "visible": true,
        "bind": "",
        "classNameTags": [],
        "persistBlock": false,
        "copy": false,
        "icon": "",
        "iconGap": 5,
        "widthHeight": "",
        "copyText": "",
        "background": "#000000",
        "borderRadius": 16,
        "borderWidth": 0,
        "borderColor": "#0000FF",
        "fontSize": "",
        "fontWeight": "",
        "fontColor": "#FFFFFF",
        "padding": {
          "overall": 6,
          "top": "0",
          "right": "0",
          "bottom": "0",
          "left": "0"
        },
        "enableBadge": false,
        "onClick": "async function main(asset, flatlistData) {\n  // Start of editable area\n  \n  // End of editable area\n}"
      },
      "text": "name"
    }
  }
}
export const emailText: any = {
  type: "Component",
  json: {
    type: 'Text',
    label: 'name',
    properties: {
      "styles": {
        "common": {
          "textAlign": "",
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "badgeBackground": "#D20202",
            "badgeTextColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "badgeBorderWidth": 1,
            "badgeBorderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "14",
          "height": "20",
          "width": "100",
          "color": "#425466",
          "backgroundColor": "#00000000"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "14",
          "height": "20",
          "width": "100",
          "color": "#425466",
          "backgroundColor": "#00000000"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "14",
          "height": "20",
          "width": "100",
          "color": "#425466",
          "backgroundColor": "#00000000"
        }
      },
      "config": {
        "visible": true,
        "bind": "",
        "classNameTags": [],
        "persistBlock": false,
        "copy": false,
        "icon": "",
        "iconGap": 5,
        "widthHeight": "",
        "copyText": "",
        "background": "#000000",
        "borderRadius": 16,
        "borderWidth": 0,
        "borderColor": "#0000FF",
        "fontSize": "",
        "fontWeight": "",
        "fontColor": "#FFFFFF",
        "padding": {
          "overall": 6,
          "top": "0",
          "right": "0",
          "bottom": "0",
          "left": "0"
        },
        "enableBadge": false,
        "onClick": "async function main(asset, flatlistData) {\n  // Start of editable area\n  \n  // End of editable area\n}"
      },
      "text": "email@autonom8.com"
    }
  }
}

export const datatemp2: any = {
  type: "Component",
  json: {
    type: 'Row',
    label: 'Row',
    properties: {
      "styles": {
        "common": {
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "background": "#D20202",
            "textColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "borderWidth": 1,
            "borderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "width": "100",
          "heightMode": "px",
          "height": "80",
          "padding": "16",
          "backgroundColor": "#00000000",
          "borderColor": "#C5C8D4",
          "borderRadius": "10",
          "gap": "16",
          "border": "1"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "width": "100",
          "heightMode": "px",
          "height": "80",
          "padding": "16",
          "backgroundColor": "#00000000",
          "borderColor": "#C5C8D4",
          "borderRadius": "10",
          "gap": "16",
          "border": "1"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "width": "100",
          "heightMode": "px",
          "height": "80",
          "padding": "16",
          "backgroundColor": "#00000000",
          "borderColor": "#C5C8D4",
          "borderRadius": "10",
          "gap": "16",
          "border": "1"
        }
      },
      "config": {
        "visible": true,
        "enableBadge": false,
        "classNameTags": [],
        "onClick": "async function main(asset, flatlistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }",
        "renderOn": ""
      }
    }
  }
}

export const avatartemp2: any = {
  type: "Component",
  json: {
    type: 'Avatar',
    label: 'Avatar',
    properties: {
      "styles": {
        "common": {
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "background": "#D20202",
            "textColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "borderWidth": 1,
            "borderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "px",
          "width": "48",
          "height": "48"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "px",
          "width": "48",
          "height": "48"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "px",
          "width": "48",
          "height": "48"
        }
      },
      "config": {
        "visible": true,
        "bind": "",
        "classNameTags": [],
        "persistBlock": false,
        "avatarDimension": "48",
        "avatarUrl": "https://storage.googleapis.com/public-a8-bucket/24c2e9de-de12-42f5-b70a-55fcd21c7b83/apps/310a0b83-b512-40e8-a057-5a4fdf730534/large-photo_1717071708622.svg",
        "enableBadge": false,
        "enableOnHistoryView": false,
        "onClick": "async function main(asset, flalistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }"
      }
    }
  }
}

export const columntemp2: any = {
  type: "Component",
  json: {
    type: 'Column',
    label: 'Column',
    properties: {
      "styles": {
        "common": {
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "background": "#D20202",
            "textColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "borderWidth": 1,
            "borderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "%",
          "height": "100",
          "width": "300",
          "backgroundColor": "#00000000",
          "padding": "0",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingBottom": "0",
          "paddingLeft": "0"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "%",
          "height": "100",
          "width": "300",
          "backgroundColor": "#00000000",
          "padding": "0",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingBottom": "0",
          "paddingLeft": "0"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "px",
          "heightMode": "%",
          "height": "100",
          "width": "300",
          "backgroundColor": "#00000000",
          "padding": "0",
          "paddingTop": "0",
          "paddingRight": "0",
          "paddingBottom": "0",
          "paddingLeft": "0"
        }
      },
      "config": {
        "visible": true,
        "enableBadge": false,
        "classNameTags": [],
        "onClick": "async function main(asset, flatlistData) {\n      // Start of editable area\n      \n      // End of editable area\n    }",
        "renderOn": ""
      }
    }
  }
}

export const nameTexttemp2: any = {
  type: "Component",
  json: {
    type: 'Text',
    label: 'satheesh',
    properties: {
      "styles": {
        "common": {
          "textAlign": "",
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "badgeBackground": "#D20202",
            "badgeTextColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "badgeBorderWidth": 1,
            "badgeBorderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "16",
          "width": "100",
          "fontWeight": "600",
          "height": "25",
          "color": "#27272E",
          "backgroundColor": "#00000000"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "16",
          "width": "100",
          "fontWeight": "600",
          "height": "25",
          "color": "#27272E",
          "backgroundColor": "#00000000"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "16",
          "width": "100",
          "fontWeight": "600",
          "height": "25",
          "color": "#27272E",
          "backgroundColor": "#00000000"
        }
      },
      "config": {
        "visible": true,
        "bind": "",
        "classNameTags": [],
        "persistBlock": false,
        "copy": false,
        "icon": "",
        "iconGap": 5,
        "widthHeight": "",
        "copyText": "",
        "background": "#000000",
        "borderRadius": 16,
        "borderWidth": 0,
        "borderColor": "#0000FF",
        "fontSize": "",
        "fontWeight": "",
        "fontColor": "#FFFFFF",
        "padding": {
          "overall": 6,
          "top": "0",
          "right": "0",
          "bottom": "0",
          "left": "0"
        },
        "enableBadge": false,
        "onClick": "async function main(asset, flatlistData) {\n  // Start of editable area\n  \n  // End of editable area\n}"
      },
      "text": "name"
    }
  }
}
export const emailTexttemp2: any = {
  type: "Component",
  json: {
    type: 'Text',
    label: 'satheesh',
    properties: {
      "styles": {
        "common": {
          "textAlign": "",
          "badge": {
            "badgeBindBadge": "",
            "defaultValue": 10,
            "badgeBackground": "#D20202",
            "badgeTextColor": "#fff",
            "badgeFontSize": 14,
            "badgeBorderRadius": 20,
            "badgeBorderWidth": 1,
            "badgeBorderColor": "#FFFFFF",
            "position": "custom",
            "customVertical": "top",
            "customHorizontal": "right"
          }
        },
        "Sm": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "14",
          "height": "20",
          "width": "100",
          "color": "#425466",
          "backgroundColor": "#00000000"
        },
        "Md": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "14",
          "height": "20",
          "width": "100",
          "color": "#425466",
          "backgroundColor": "#00000000"
        },
        "Lg": {
          "gridCols": "1",
          "gridRows": "0",
          "span": "1",
          "rowSpan": "1",
          "visible": true,
          "widthMode": "%",
          "heightMode": "px",
          "fontSize": "14",
          "height": "20",
          "width": "100",
          "color": "#425466",
          "backgroundColor": "#00000000"
        }
      },
      "config": {
        "visible": true,
        "bind": "",
        "classNameTags": [],
        "persistBlock": false,
        "copy": false,
        "icon": "",
        "iconGap": 5,
        "widthHeight": "",
        "copyText": "",
        "background": "#000000",
        "borderRadius": 16,
        "borderWidth": 0,
        "borderColor": "#0000FF",
        "fontSize": "",
        "fontWeight": "",
        "fontColor": "#FFFFFF",
        "padding": {
          "overall": 6,
          "top": "0",
          "right": "0",
          "bottom": "0",
          "left": "0"
        },
        "enableBadge": false,
        "onClick": "async function main(asset, flatlistData) {\n  // Start of editable area\n  \n  // End of editable area\n}"
      },
      "text": "email@autonom8.com"
    }
  }
}
